<template>
    <div id="weather" class="panel-body" transition-duration="0.3s">
        <div class="row" v-masonry item-selector=".news-item" horizontal-order="true">
            <article v-masonry-tile v-for="(item, index) in items"
                     class="weather news-item news-event col-xs-12 col-sm-6 col-md-3"
                     v-bind:class="wStatus(item)">
                <a href="#" v-bind:data-target="'#event-' + index" data-toggle="modal">
                    <div class="news-category sun sun-primary">
                <span class="sun-row">
                    <span class="sun-cell sun-empty-2"></span>
                    <span class="sun-cell current sun-primary sun-inverse"><span class="sun-inner-cell">En cours</span></span>
                    <span class="sun-cell future sun-gray-light sun-inverse"><span
                            class="sun-inner-cell">Planifié</span></span>
                    <span class="sun-cell sun-empty-1"></span>
                    <span class="sun-cell sun-empty-6"></span>
                </span>
                    </div>
                    <div class="news-content">
                        <h3 class="news-title" v-html="item.title"></h3>
                        <div class="news-labels">
                            <div v-if="item.priority == 'high'" class="label label-danger">Criticité forte</div>
                            <!--<div class="label label-default">${item.duration} minute(s) d'interruption</div>-->
                        </div>
                    </div>
                    <div class="event-infos">
                        <div class="event-date">
                            <div class="event-date-container">
                                Du {{item.start | moment }}<br>au {{item.end | moment}}
                            </div>
                        </div>
                    </div>
                </a>
                <!-- Modal -->
                <div class="modal fade modal-center" v-bind:id="'event-' + index" tabindex="-1" role="dialog"
                     v-bind:aria-labelledby="'event-title-' + index">
                    <div class="flex-container">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                            aria-hidden="true">&times;</span></button>
                                    <div class="news-content">
                                        <h3 class="news-title" v-html="item.title"
                                            v-bind:id="'event-title-' + index"></h3>
                                        <div class="news-labels">
                                            <div v-if="item.priority == 'high'" class="label label-danger">Criticité
                                                forte
                                            </div>
                                            <div class="label label-default">{{item.duration}} minute(s)
                                                d'interruption
                                            </div>
                                        </div>
                                    </div>
                                    <div class="event-infos">
                                        <div class="event-date">
                                            <div class="event-date-container">
                                                Du {{item.start | moment }}<br>au {{item.end | moment}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <div class="news-subheader" v-html="item.content"></div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default" data-dismiss="modal">Fermer</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </div>
    </div>
</template>


<script>
    import moment from 'moment';
    import {VueMasonryPlugin} from 'vue-masonry';

    export default {
        name: "weather",
        components: {},
        data() {
            return {
                items: null,
                path: null,
                message: "main"
            }
        },
        created: function () {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                var self = this;
                this.$http.get(portal_conf["weather"]).then(response => {
                    var arr = response.body;

                    function comp(a, b) {
                        return new Date(b.start).getTime() - new Date(a.start).getTime();
                    }

                    self.items = arr.sort(comp);

                }, response => {
                    console.error("Error during retrieving data");
                });

            },
            wStatus: function (item) {
                if (moment(item.end).isAfter(moment()) && moment(item.start).isAfter(moment())) return "w-future";
                if (moment(item.end).isAfter(moment()) && moment(item.start).isBefore(moment())) return "w-current";
                return "w-past";
            }
        },
        filters: {
            moment: function (date) {
                let m = moment(date);
                return m.locale('fr').format('Do MMM YYYY H[h]mm');
            }
        }

    }
</script>


<style scoped>

    .panel-transparent {
        border-color: transparent;
        background-color: transparent
    }

    .panel-transparent .panel-body {
        padding: 15px 0
    }

    .row {
        margin-left: -15px;
        margin-right: -15px
    }

    h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, legend, .h4, .h5, .h6 {
        font-family: inherit;
        font-weight: 500;
        line-height: 1.1;
        color: inherit
    }

    .col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {
        position: relative;
        min-height: 1px;
        padding-left: 15px;
        padding-right: 15px
    }

    .col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12 {
        float: left
    }

    .col-xs-1 {
        width: 8.33333%
    }

    .col-xs-2 {
        width: 16.66667%
    }

    .col-xs-3 {
        width: 25%
    }

    .col-xs-4 {
        width: 33.33333%
    }

    .col-xs-5 {
        width: 41.66667%
    }

    .col-xs-6 {
        width: 50%
    }

    .col-xs-7 {
        width: 58.33333%
    }

    .col-xs-8 {
        width: 66.66667%
    }

    .col-xs-9 {
        width: 75%
    }

    .col-xs-10 {
        width: 83.33333%
    }

    .col-xs-11 {
        width: 91.66667%
    }

    .col-xs-12 {
        width: 100%
    }

    .col-xs-pull-0 {
        right: auto
    }

    .col-xs-pull-1 {
        right: 8.33333%
    }

    .col-xs-pull-2 {
        right: 16.66667%
    }

    .col-xs-pull-3 {
        right: 25%
    }

    .col-xs-pull-4 {
        right: 33.33333%
    }

    .col-xs-pull-5 {
        right: 41.66667%
    }

    .col-xs-pull-6 {
        right: 50%
    }

    .col-xs-pull-7 {
        right: 58.33333%
    }

    .col-xs-pull-8 {
        right: 66.66667%
    }

    .col-xs-pull-9 {
        right: 75%
    }

    .col-xs-pull-10 {
        right: 83.33333%
    }

    .col-xs-pull-11 {
        right: 91.66667%
    }

    .col-xs-pull-12 {
        right: 100%
    }

    .col-xs-push-0 {
        left: auto
    }

    .col-xs-push-1 {
        left: 8.33333%
    }

    .col-xs-push-2 {
        left: 16.66667%
    }

    .col-xs-push-3 {
        left: 25%
    }

    .col-xs-push-4 {
        left: 33.33333%
    }

    .col-xs-push-5 {
        left: 41.66667%
    }

    .col-xs-push-6 {
        left: 50%
    }

    .col-xs-push-7 {
        left: 58.33333%
    }

    .col-xs-push-8 {
        left: 66.66667%
    }

    .col-xs-push-9 {
        left: 75%
    }

    .col-xs-push-10 {
        left: 83.33333%
    }

    .col-xs-push-11 {
        left: 91.66667%
    }

    .col-xs-push-12 {
        left: 100%
    }

    .col-xs-offset-0 {
        margin-left: 0%
    }

    .col-xs-offset-1 {
        margin-left: 8.33333%
    }

    .col-xs-offset-2 {
        margin-left: 16.66667%
    }

    .col-xs-offset-3 {
        margin-left: 25%
    }

    .col-xs-offset-4 {
        margin-left: 33.33333%
    }

    .col-xs-offset-5 {
        margin-left: 41.66667%
    }

    .col-xs-offset-6 {
        margin-left: 50%
    }

    .col-xs-offset-7 {
        margin-left: 58.33333%
    }

    .col-xs-offset-8 {
        margin-left: 66.66667%
    }

    .col-xs-offset-9 {
        margin-left: 75%
    }

    .col-xs-offset-10 {
        margin-left: 83.33333%
    }

    .col-xs-offset-11 {
        margin-left: 91.66667%
    }

    .col-xs-offset-12 {
        margin-left: 100%
    }

    @media (min-width: 768px) {
        .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {
            float: left
        }

        .col-sm-1 {
            width: 8.33333%
        }

        .col-sm-2 {
            width: 16.66667%
        }

        .col-sm-3 {
            width: 25%
        }

        .col-sm-4 {
            width: 33.33333%
        }

        .col-sm-5 {
            width: 41.66667%
        }

        .col-sm-6 {
            width: 50%
        }

        .col-sm-7 {
            width: 58.33333%
        }

        .col-sm-8 {
            width: 66.66667%
        }

        .col-sm-9 {
            width: 75%
        }

        .col-sm-10 {
            width: 83.33333%
        }

        .col-sm-11 {
            width: 91.66667%
        }

        .col-sm-12 {
            width: 100%
        }

        .col-sm-pull-0 {
            right: auto
        }

        .col-sm-pull-1 {
            right: 8.33333%
        }

        .col-sm-pull-2 {
            right: 16.66667%
        }

        .col-sm-pull-3 {
            right: 25%
        }

        .col-sm-pull-4 {
            right: 33.33333%
        }

        .col-sm-pull-5 {
            right: 41.66667%
        }

        .col-sm-pull-6 {
            right: 50%
        }

        .col-sm-pull-7 {
            right: 58.33333%
        }

        .col-sm-pull-8 {
            right: 66.66667%
        }

        .col-sm-pull-9 {
            right: 75%
        }

        .col-sm-pull-10 {
            right: 83.33333%
        }

        .col-sm-pull-11 {
            right: 91.66667%
        }

        .col-sm-pull-12 {
            right: 100%
        }

        .col-sm-push-0 {
            left: auto
        }

        .col-sm-push-1 {
            left: 8.33333%
        }

        .col-sm-push-2 {
            left: 16.66667%
        }

        .col-sm-push-3 {
            left: 25%
        }

        .col-sm-push-4 {
            left: 33.33333%
        }

        .col-sm-push-5 {
            left: 41.66667%
        }

        .col-sm-push-6 {
            left: 50%
        }

        .col-sm-push-7 {
            left: 58.33333%
        }

        .col-sm-push-8 {
            left: 66.66667%
        }

        .col-sm-push-9 {
            left: 75%
        }

        .col-sm-push-10 {
            left: 83.33333%
        }

        .col-sm-push-11 {
            left: 91.66667%
        }

        .col-sm-push-12 {
            left: 100%
        }

        .col-sm-offset-0 {
            margin-left: 0%
        }

        .col-sm-offset-1 {
            margin-left: 8.33333%
        }

        .col-sm-offset-2 {
            margin-left: 16.66667%
        }

        .col-sm-offset-3 {
            margin-left: 25%
        }

        .col-sm-offset-4 {
            margin-left: 33.33333%
        }

        .col-sm-offset-5 {
            margin-left: 41.66667%
        }

        .col-sm-offset-6 {
            margin-left: 50%
        }

        .col-sm-offset-7 {
            margin-left: 58.33333%
        }

        .col-sm-offset-8 {
            margin-left: 66.66667%
        }

        .col-sm-offset-9 {
            margin-left: 75%
        }

        .col-sm-offset-10 {
            margin-left: 83.33333%
        }

        .col-sm-offset-11 {
            margin-left: 91.66667%
        }

        .col-sm-offset-12 {
            margin-left: 100%
        }
    }

    @media (min-width: 992px) {
        .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12 {
            float: left
        }

        .col-md-1 {
            width: 8.33333%
        }

        .col-md-2 {
            width: 16.66667%
        }

        .col-md-3 {
            width: 25%
        }

        .col-md-4 {
            width: 33.33333%
        }

        .col-md-5 {
            width: 41.66667%
        }

        .col-md-6 {
            width: 50%
        }

        .col-md-7 {
            width: 58.33333%
        }

        .col-md-8 {
            width: 66.66667%
        }

        .col-md-9 {
            width: 75%
        }

        .col-md-10 {
            width: 83.33333%
        }

        .col-md-11 {
            width: 91.66667%
        }

        .col-md-12 {
            width: 100%
        }

        .col-md-pull-0 {
            right: auto
        }

        .col-md-pull-1 {
            right: 8.33333%
        }

        .col-md-pull-2 {
            right: 16.66667%
        }

        .col-md-pull-3 {
            right: 25%
        }

        .col-md-pull-4 {
            right: 33.33333%
        }

        .col-md-pull-5 {
            right: 41.66667%
        }

        .col-md-pull-6 {
            right: 50%
        }

        .col-md-pull-7 {
            right: 58.33333%
        }

        .col-md-pull-8 {
            right: 66.66667%
        }

        .col-md-pull-9 {
            right: 75%
        }

        .col-md-pull-10 {
            right: 83.33333%
        }

        .col-md-pull-11 {
            right: 91.66667%
        }

        .col-md-pull-12 {
            right: 100%
        }

        .col-md-push-0 {
            left: auto
        }

        .col-md-push-1 {
            left: 8.33333%
        }

        .col-md-push-2 {
            left: 16.66667%
        }

        .col-md-push-3 {
            left: 25%
        }

        .col-md-push-4 {
            left: 33.33333%
        }

        .col-md-push-5 {
            left: 41.66667%
        }

        .col-md-push-6 {
            left: 50%
        }

        .col-md-push-7 {
            left: 58.33333%
        }

        .col-md-push-8 {
            left: 66.66667%
        }

        .col-md-push-9 {
            left: 75%
        }

        .col-md-push-10 {
            left: 83.33333%
        }

        .col-md-push-11 {
            left: 91.66667%
        }

        .col-md-push-12 {
            left: 100%
        }

        .col-md-offset-0 {
            margin-left: 0%
        }

        .col-md-offset-1 {
            margin-left: 8.33333%
        }

        .col-md-offset-2 {
            margin-left: 16.66667%
        }

        .col-md-offset-3 {
            margin-left: 25%
        }

        .col-md-offset-4 {
            margin-left: 33.33333%
        }

        .col-md-offset-5 {
            margin-left: 41.66667%
        }

        .col-md-offset-6 {
            margin-left: 50%
        }

        .col-md-offset-7 {
            margin-left: 58.33333%
        }

        .col-md-offset-8 {
            margin-left: 66.66667%
        }

        .col-md-offset-9 {
            margin-left: 75%
        }

        .col-md-offset-10 {
            margin-left: 83.33333%
        }

        .col-md-offset-11 {
            margin-left: 91.66667%
        }

        .col-md-offset-12 {
            margin-left: 100%
        }
    }

    @media (min-width: 1200px) {
        .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12 {
            float: left
        }

        .col-lg-1 {
            width: 8.33333%
        }

        .col-lg-2 {
            width: 16.66667%
        }

        .col-lg-3 {
            width: 25%
        }

        .col-lg-4 {
            width: 33.33333%
        }

        .col-lg-5 {
            width: 41.66667%
        }

        .col-lg-6 {
            width: 50%
        }

        .col-lg-7 {
            width: 58.33333%
        }

        .col-lg-8 {
            width: 66.66667%
        }

        .col-lg-9 {
            width: 75%
        }

        .col-lg-10 {
            width: 83.33333%
        }

        .col-lg-11 {
            width: 91.66667%
        }

        .col-lg-12 {
            width: 100%
        }

        .col-lg-pull-0 {
            right: auto
        }

        .col-lg-pull-1 {
            right: 8.33333%
        }

        .col-lg-pull-2 {
            right: 16.66667%
        }

        .col-lg-pull-3 {
            right: 25%
        }

        .col-lg-pull-4 {
            right: 33.33333%
        }

        .col-lg-pull-5 {
            right: 41.66667%
        }

        .col-lg-pull-6 {
            right: 50%
        }

        .col-lg-pull-7 {
            right: 58.33333%
        }

        .col-lg-pull-8 {
            right: 66.66667%
        }

        .col-lg-pull-9 {
            right: 75%
        }

        .col-lg-pull-10 {
            right: 83.33333%
        }

        .col-lg-pull-11 {
            right: 91.66667%
        }

        .col-lg-pull-12 {
            right: 100%
        }

        .col-lg-push-0 {
            left: auto
        }

        .col-lg-push-1 {
            left: 8.33333%
        }

        .col-lg-push-2 {
            left: 16.66667%
        }

        .col-lg-push-3 {
            left: 25%
        }

        .col-lg-push-4 {
            left: 33.33333%
        }

        .col-lg-push-5 {
            left: 41.66667%
        }

        .col-lg-push-6 {
            left: 50%
        }

        .col-lg-push-7 {
            left: 58.33333%
        }

        .col-lg-push-8 {
            left: 66.66667%
        }

        .col-lg-push-9 {
            left: 75%
        }

        .col-lg-push-10 {
            left: 83.33333%
        }

        .col-lg-push-11 {
            left: 91.66667%
        }

        .col-lg-push-12 {
            left: 100%
        }

        .col-lg-offset-0 {
            margin-left: 0%
        }

        .col-lg-offset-1 {
            margin-left: 8.33333%
        }

        .col-lg-offset-2 {
            margin-left: 16.66667%
        }

        .col-lg-offset-3 {
            margin-left: 25%
        }

        .col-lg-offset-4 {
            margin-left: 33.33333%
        }

        .col-lg-offset-5 {
            margin-left: 41.66667%
        }

        .col-lg-offset-6 {
            margin-left: 50%
        }

        .col-lg-offset-7 {
            margin-left: 58.33333%
        }

        .col-lg-offset-8 {
            margin-left: 66.66667%
        }

        .col-lg-offset-9 {
            margin-left: 75%
        }

        .col-lg-offset-10 {
            margin-left: 83.33333%
        }

        .col-lg-offset-11 {
            margin-left: 91.66667%
        }

        .col-lg-offset-12 {
            margin-left: 100%
        }
    }

    .sun, .sun * {
        box-sizing: border-box
    }

    .sun {
        font-size: 1em;
        font-family: "Unistra A";
        margin: -1px 0 0 0;
        padding: 1px 0 0 0
    }

    [hidden], template {
        display: none
    }

    .news-item > a, .news-item > .news-media-container, .news-item > .news-scolarite-container {
        background: white
    }

    .news-item > a {
        text-decoration: none;
        display: -webkit-flex;
        display: flex;
        -webkit-flex-direction: column;
        flex-direction: column;
        color: #1b2126;
        position: relative;
        height: 100%;
        margin: 15px 0
    }

    .news-item > a:hover, .news-item > a:focus {
        background-color: #f6f6f3
    }

    .news-item > a:hover .news-image, .news-item > a:focus .news-image {
        opacity: .8;
        filter: alpha(opacity=80);
        -webkit-transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        transition: all 0.3s ease
    }

    .news-item.w-current > a, .news-item.w-future > a {
        border: 1px solid #0f65a5
    }

    .news-item.w-current > a .news-category, .news-item.w-future > a .news-category {
        margin-top: -1px;
        margin-left: -1px
    }

    .news-item.w-current > a .news-category .future {
        display: none !important
    }

    .news-item.w-future > a .news-category .current {
        display: none !important
    }

    .news-item.w-past > a .news-category {
        display: none !important
    }

    .news-item .news-datepub {
        font-size: 75%;
        font-weight: bold;
        color: #3d4b57
    }

    .news-item .news-infos {
        -webkit-flex: 1 1 auto;
        flex: 1 1 auto;
        display: -webkit-flex;
        display: flex;
        -webkit-flex-direction: column;
        flex-direction: column
    }

    .news-item .news-image-container {
        height: 120px;
        overflow: hidden
    }

    .news-item .news-labels {
        margin-top: 15px
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .news-item .news-image-container {
            height: 160px
        }
    }

    .news-item .news-image {
        display: block;
        position: relative;
        height: 100%;
        -webkit-filter: brightness(.97);
        filter: brightness(.97);
        -webkit-transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        transition: all 0.3s ease
    }

    .news-item .news-image img {
        position: absolute;
        object-fit: cover;
        width: 100%;
        height: 100%;
        -webkit-transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        transition: all 0.3s ease
    }

    .news-item .news-category {
        font-size: 1em;
        overflow-x: hidden;
        margin-top: 0
    }

    .news-item .news-content {
        padding: 30px;
        -webkit-flex: 1 1 auto;
        flex: 1 1 auto;
        display: -webkit-flex;
        display: flex;
        -webkit-flex-direction: column;
        flex-direction: column;
        -webkit-justify-content: center;
        justify-content: center
    }

    .news-item .news-title {
        margin-top: 0;
        color: #1b2126
    }

    .news-item .news-title a {
        font-weight: normal
    }

    .news-item .news-title::first-letter {
        text-transform: uppercase
    }

    .news-item h2.news-title {
        margin-bottom: 11px
    }

    .news-item h3.news-title {
        font-size: 18px
    }

    .news-item h3:not(.news-title) {
        margin-top: 0
    }

    .news-item h3:not(.news-title) small {
        font-size: 18px;
        color: #1b2126
    }

    .news-item.news-event .news-datepub {
        display: none
    }

    .news-item.news-event .news-title {
        margin-bottom: 0
    }

    .news-item .news-subheader {
        font-size: 16px;
        margin-bottom: 0
    }

    .news-item.news-recherche .news-title {
        font-family: Brill, "Times New Roman", Times, serif
    }

    .news-item .event-infos {
        display: none;
        -webkit-flex-direction: column;
        flex-direction: column;
        -webkit-align-items: flex-end;
        align-items: flex-end;
        font-size: 16px;
        padding: 0 0 30px
    }

    .news-item .event-infos .us, .news-item .event-infos .nv, .news-item .event-infos .fa {
        color: #0f65a5
    }

    .news-item.news-event .event-infos {
        display: -webkit-flex;
        display: flex
    }

    .news-item .event-date, .news-item .event-hour, .news-item .event-place {
        padding: 0 30px;
        text-align: right;
        width: 100%
    }

    .news-item .event-date {
        display: -webkit-flex;
        display: flex;
        position: relative
    }

    .news-item .event-date::before {
        content: "";
        flex: 1;
        height: 3px;
        background: #819bb0;
        margin: 0.5em 10px 0 -30px
    }

    .news-item .event-date::after {
        content: "";
        position: absolute;
        height: 3px;
        background: #819bb0;
        margin: 0.5em 0 0 10px;
        width: 20px;
        right: 0
    }

    .news-item .event-place {
        font-style: italic;
        margin-top: 11px
    }

    @media (min-width: 768px) {
        body.home .news-latest:not(.news-newsletter) .news-item:only-child {
            width: 100%
        }
    }

    @media (max-width: 767px) {
        body.home .news-latest .news-item:nth-child(1) {
            margin-bottom: 30px
        }

        body.home .news-latest .news-item:last-child {
            margin-bottom: 0
        }
    }

    @media (max-width: 767px) {
        body.home .news-latest.news-medias .news-item:nth-child(2), body.home .news-latest.news-scolarite .news-item:nth-child(2) {
            margin-bottom: 0
        }
    }

    .weather.news-item:not(:nth-child(-n+8)) {
        display: none
    }

    @media (max-width: 767px) {
        .weather.news-item:not(:nth-child(-n+6)) {
            display: none
        }
    }

    .close {
        float: right;
        font-size: 18px;
        font-weight: normal;
        line-height: 1;
        color: #1b2126;
        text-shadow: none;
        opacity: .4;
        filter: alpha(opacity=40)
    }

    .close:hover, .close:focus {
        color: #1b2126;
        text-decoration: none;
        cursor: pointer;
        opacity: .6;
        filter: alpha(opacity=60)
    }

    button.close {
        padding: 0;
        cursor: pointer;
        background: transparent;
        border: 0;
        -webkit-appearance: none
    }

    .modal-open {
        overflow: hidden
    }

    .modal {
        display: none;
        overflow: hidden;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1050;
        -webkit-overflow-scrolling: touch;
        outline: 0
    }

    .modal.fade .modal-dialog {
        -webkit-transform: translate(0, -25%);
        -ms-transform: translate(0, -25%);
        -o-transform: translate(0, -25%);
        transform: translate(0, -25%);
        -webkit-transition: -webkit-transform 0.3s ease-out;
        -moz-transition: -moz-transform 0.3s ease-out;
        -o-transition: -o-transform 0.3s ease-out;
        transition: transform 0.3s ease-out
    }

    .modal.in .modal-dialog {
        -webkit-transform: translate(0, 0);
        -ms-transform: translate(0, 0);
        -o-transform: translate(0, 0);
        transform: translate(0, 0)
    }

    .modal-open .modal {
        overflow-x: hidden;
        overflow-y: auto
    }

    .modal-dialog {
        position: relative;
        width: auto;
        margin: 10px
    }

    .modal-content {
        position: relative;
        background-color: #fff;
        border: 1px solid #c6cfd7;
        border: 1px solid #c6cfd7;
        border-radius: 0;
        -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
        box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
        background-clip: padding-box;
        outline: 0
    }

    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1040;
        background-color: #000
    }

    .modal-backdrop.fade {
        opacity: 0;
        filter: alpha(opacity=0)
    }

    .modal-backdrop.in {
        opacity: .5;
        filter: alpha(opacity=50)
    }

    .modal-header {
        padding: 15px;
        border-bottom: 1px solid #c6cfd7
    }

    .modal-header:before, .modal-header:after {
        content: " ";
        display: table
    }

    .modal-header:after {
        clear: both
    }

    .modal-header .close {
        margin-top: -2px
    }

    .modal-title {
        margin: 0;
        line-height: 1.22222
    }

    .modal-body {
        position: relative;
        padding: 15px
    }

    .modal-footer {
        padding: 15px;
        text-align: right;
        border-top: 1px solid #c6cfd7
    }

    .modal-footer:before, .modal-footer:after {
        content: " ";
        display: table
    }

    .modal-footer:after {
        clear: both
    }

    .modal-footer .btn + .btn {
        margin-left: 5px;
        margin-bottom: 0
    }

    .modal-footer .btn-group .btn + .btn {
        margin-left: -1px
    }

    .modal-footer .btn-block + .btn-block {
        margin-left: 0
    }

    .modal-scrollbar-measure {
        position: absolute;
        top: -9999px;
        width: 50px;
        height: 50px;
        overflow: scroll
    }

    .fade {
        opacity: 0;
        -webkit-transition: opacity 0.15s linear;
        -o-transition: opacity 0.15s linear;
        transition: opacity 0.15s linear
    }

    .fade.in {
        opacity: 1
    }

    .collapse:not(#nav-mobile) {
        display: none
    }

    .collapse:not(#nav-mobile).in {
        display: block
    }

    tr.collapse.in {
        display: table-row
    }

    tbody.collapse.in {
        display: table-row-group
    }

    .collapsing:not(#nav-mobile) {
        position: relative;
        height: 0;
        overflow: hidden;
        -webkit-transition-property: height, visibility;
        transition-property: height, visibility;
        -webkit-transition-duration: 0.35s;
        transition-duration: 0.35s;
        -webkit-transition-timing-function: ease;
        transition-timing-function: ease
    }

    .label-danger {
        background-color: #d9534f
    }

    .label-danger[href]:hover, .label-danger[href]:focus {
        background-color: #c9302c
    }

    .label-default {

        background-color: #819bb0;

    }

    .label {
        display: inline;
        padding: .2em .6em .18em;
        font-size: 75%;
        font-weight: bold;
        line-height: 1;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: 0
    }

    @media (min-width: 768px) {
        .modal-dialog {
            width: 600px;
            margin: 30px auto
        }

        .modal-content {
            -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5)
        }

        .modal-sm {
            width: 300px
        }
    }

    @media (min-width: 992px) {
        .modal-lg {
            width: 900px
        }
    }

    * {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box
    }

    *:before, *:after {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box
    }

    h3, .h3, legend {
        font-size: 22px;
        font-weight: bold;
    }

    button.close {

        padding: 0;
        cursor: pointer;
        background: transparent;
        border: 0;
        -webkit-appearance: none;

    }

    .close {

        float: right;
        font-size: 18px;
        font-weight: normal;
        line-height: 1;
        color: #1b2126;
        text-shadow: none;
        opacity: .4;
        filter: alpha(opacity=40);

    }

    .btn {

        display: inline-block;
        margin-bottom: 0;
        font-weight: normal;
        text-align: center;
        vertical-align: middle;
        touch-action: manipulation;
        cursor: pointer;
        background-image: none;
        border: 1px solid transparent;
        border-top-color: transparent;
        border-right-color: transparent;
        border-bottom-color: transparent;
        border-left-color: transparent;
        white-space: nowrap;
        text-decoration: none;
        padding: 6px 12px 6px;
        font-size: 18px;
        line-height: 1.22222;
        border-radius: 0;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

    }

    .btn-default {

        color: #1b2126;
        background-color: #fff;
        border-color: #c6cfd7;

    }

    .btn:hover, .btn:focus, .btn.focus {

        color: #1b2126;
        text-decoration: none;

    }

    .btn-default:hover {

        color: #1b2126;
        background-color: #eceee8;
        border-color: #a2b1be;

    }


</style>



// WEBPACK FOOTER //
// src/weather/src/weather.vue